import { render, staticRenderFns } from "./References.vue?vue&type=template&id=2fee80a7&scoped=true"
import script from "./References.vue?vue&type=script&lang=js"
export * from "./References.vue?vue&type=script&lang=js"
import style0 from "./References.vue?vue&type=style&index=0&id=2fee80a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fee80a7",
  null
  
)

export default component.exports